import { ErrorMessage, Field } from "formik";
import React, { memo } from "react";
import ErrorMsg from "./ErrorMsg";
const TextField = ({ type, name, id, label, className, children, ...rest }) => {
    return (
        <div className="form-group mb-4 relative">
            {label && (
                <label
                    htmlFor={id}
                    className="block  text-sm md:text-[1rem] mb-2"
                >
                    {label}:
                </label>
            )}
            <div className="relative">
                <Field
                    className={`p-2 relative w-full  border  transition-all  rounded-xl focus:border-third-color shadow-sm outline-none border-light-color ${className}`}
                    name={name}
                    type={type}
                    id={id}
                    {...rest}
                />
                {children}
            </div>
            <ErrorMessage name={name} component={ErrorMsg} />
        </div>
    );
};

export default memo(TextField);
